/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Image_AuditsInputs */



/**
* | output |
* | --- |
* | "Navigation and communication consoles on a ship's bridge" |
*
* @param {Services_Image_AuditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const services_image_audits = /** @type {((inputs?: Services_Image_AuditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Image_AuditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("船舶驾驶台上的导航与通信控制台")
	return /** @type {LocalizedString} */ ("Navigation and communication consoles on a ship's bridge")
});